<template>
  <div>
    <Head title="Reportes" />
    <h1 class="mb-8 text-3xl font-bold">Reportes y Estadísticas</h1>

    <div class="bg-white rounded-lg shadow-sm p-6 mb-6">
      <div class="flex flex-wrap -mb-8 -mr-6">
        <text-input v-model="form.from" label="Desde" class="pb-8 pr-6 w-full lg:w-1/3" type="date" />
        <text-input v-model="form.to" label="Hasta" class="pb-8 pr-6 w-full lg:w-1/3" type="date" />
        <select-input v-model="form.organization_id" label="Tienda" class="pb-8 pr-6 w-full lg:w-1/3">
          <option value="">Todas las tiendas</option>
          <option v-for="org in organizations" :key="org.id" :value="org.id">{{ org.name }}</option>
        </select-input>
        <select-input v-model="form.modality" label="Modalidad" class="pb-8 pr-6 w-full lg:w-1/3">
          <option value="">Seleccionar</option>
<!--        <option value="pdf">PDF</option>-->
          <option value="advance">Detallado</option>
          <option value="simple">Simple</option>
        </select-input>
        <select-input v-model="form.nulled" label="Anulados" class="pb-8 pr-6 w-full lg:w-1/3">
          <option value="">Seleccionar</option>
<!--        <option value="pdf">PDF</option>-->
          <option value="1">Si</option>
          <option value="0">No</option>
        </select-input>
        <select-input v-model="form.type" label="Formato" class="pb-8 pr-6 w-full lg:w-1/3">
          <option value="">Seleccionar</option>
<!--        <option value="pdf">PDF</option>-->
          <option value="excel">Excel</option>
        </select-input>
      </div>
      <div class="mt-8 flex justify-end">
        <button class="btn-blue" :disabled="form.processing" @click="generateReport()">Generar reporte</button>
      </div>
    </div>

    <div class="bg-white p-5 mt-2">
      <h1 class="mb-4 text-xl font-bold">Productos por deposito</h1>
      <div v-for="deposit in deposits" :key="deposit.key" class="m-2 flex flex-wrap items-center gap-2">
        <a target="_blank" :href="`/products/${deposit.id}/deposits`" class="btn-blue">Reporte Valorado: {{deposit.name}}</a>
        <a :href="`/products/${deposit.id}/physical-count-excel`"
          style="background-color: #059669; color: #ffffff;"
          class="px-4 py-2.5 text-sm font-bold rounded shadow hover:opacity-90 inline-flex items-center gap-2 cursor-pointer transition">
          <i class="fa fa-file-excel-o"></i>
          <span>Toma Física (Excel): {{ deposit.name }}</span>
        </a>
        <a target="_blank" :href="`/products/${deposit.id}/physical-count`"
          style="background-color: #1e3a8a; color: #ffffff;"
          class="px-4 py-2.5 text-sm font-bold rounded shadow hover:opacity-90 inline-flex items-center gap-2 cursor-pointer transition">
          <i class="fa fa-file-pdf-o"></i>
          <span>Toma Física (PDF): {{ deposit.name }}</span>
        </a>
      </div>
    </div>

    <div class="bg-white p-5 mt-2">
      <h1 class="mb-8 text-xl font-bold">Productos por categoria</h1>
      <div v-for="category in categories" :key="category.key" class="m-2 flex">
        <a target="_blank" :href="`/products/${category.id}/categories`" class="btn-blue">{{category.name}}</a>
      </div>
    </div>

    <div v-if="count" class="pt-3">
      <a :href="`/orders-${form.orderNumber}.xlsx`">Descarga aqui</a>
    </div>


    <div class="flex" v-if="role == 'admin' || role == 'storer'">
      <div>
        <h3 class="py-2 text-xl font-bold">Productos por agotarse</h3>
        <div class="bg-white rounded-md shadow">
          <table class="w-full">
            <thead>
              <tr class="text-left font-bold">
                <th class="pb-4 pt-6 px-6">Código</th>
                <th class="pb-4 pt-6 px-6">Nombre</th>
                <th class="pb-4 pt-6 px-6">Cantidad</th>
              </tr>
            </thead>
              <tr v-for="prod in productsSoldout" :key="prod.id">
                <td class="px-6 py-4 focus:text-indigo-500">{{ prod.code }}</td>
                <td class="px-6 py-4 focus:text-indigo-500">{{ prod.name }}</td>
                <td class="px-6 py-4 focus:text-indigo-500">{{ prod.quantity }}</td>
              </tr>
            <tr v-if="!productsSoldout">
              <td class="px-6 py-4 border-t" colspan="4">No hay productos por agotarse.</td>
            </tr>
          </table>
        </div>
      </div>
    </div>

    <!-- Reportes por depósito -->
    <div class="bg-white p-6 rounded-lg shadow-sm mb-6">
      <h2 class="text-xl font-semibold mb-4">Productos por Depósito (Valorizado con Costos)</h2>
      <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        <a 
          v-for="deposit in deposits" 
          :key="deposit.id"
          target="_blank" 
          :href="`/products/${deposit.id}/deposits`" 
          class="btn-blue text-center"
        >
          {{ deposit.name }}
        </a>
      </div>
    </div>

    <!-- Planilla de Conteo Físico para Empleados (Auditoría Ciega de Inventario) -->
    <div class="bg-white p-6 rounded-lg shadow-sm mb-6 border-l-4 border-indigo-600">
      <div class="flex items-center justify-between mb-4">
        <div>
          <h2 class="text-xl font-semibold text-gray-900">Planilla de Conteo Físico para Empleados (Auditoría Ciega)</h2>
          <p class="text-xs text-gray-600 mt-1">Reporte de auditoría sin costos ni precios, con casillas de conteo físico a mano y verificación.</p>
        </div>
      </div>
      <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        <a 
          v-for="deposit in deposits" 
          :key="'count-' + deposit.id"
          target="_blank" 
          :href="`/products/${deposit.id}/physical-count`" 
          class="px-4 py-2.5 rounded-lg font-bold text-center bg-indigo-700 hover:bg-indigo-800 text-white shadow-sm flex items-center justify-center gap-2 transition"
        >
          <i class="fa fa-clipboard-check"></i>
          <span>Conteo: {{ deposit.name }}</span>
        </a>
      </div>
    </div>

    <!-- Reporte de productos -->
    <div class="bg-white p-6 rounded-lg shadow-sm mb-6">
      <h2 class="text-xl font-semibold mb-4">Lista de Productos</h2>
      <button 
        @click="print()" 
        class="btn-blue flex items-center gap-2"
      >
        <i class="fa fa-print"></i>
        <span>Imprimir lista de precios</span>
      </button>
    </div>

    <!-- Link de descarga -->
    <div v-if="count" class="bg-green-50 p-4 rounded-lg mb-6">
      <div class="flex items-center gap-2 text-green-700">
        <i class="fa fa-check-circle"></i>
        <span>¡Reporte generado!</span>
        <a 
          :href="`/orders-${form.orderNumber}.xlsx`"
          class="ml-2 text-green-800 hover:text-green-900 underline"
        >
          Descargar archivo
        </a>
      </div>
    </div>

    <!-- Productos por agotarse -->
    <div v-if="role == 'admin' || role == 'storer'" class="bg-white p-6 rounded-lg shadow-sm">
      <h2 class="text-xl font-semibold mb-4">Productos con Stock Bajo</h2>
      <div class="overflow-x-auto">
        <table class="w-full">
          <thead>
            <tr class="text-left border-b">
              <th class="pb-3 px-4">Código</th>
              <th class="pb-3 px-4">Nombre del Producto</th>
              <th class="pb-3 px-4">Stock Actual</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="prod in productsSoldout" :key="prod.id" class="border-b hover:bg-gray-50">
              <td class="py-3 px-4">{{ prod.code }}</td>
              <td class="py-3 px-4">{{ prod.name }}</td>
              <td class="py-3 px-4">
                <span class="text-red-600 font-medium">{{ prod.quantity }}</span>
              </td>
            </tr>
            <tr v-if="!productsSoldout?.length">
              <td class="p-4 text-center text-gray-500" colspan="3">
                No hay productos con stock bajo en este momento.
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Reporte de Pisos y Techos de Inventario por Tienda (PDF / Excel) -->
    <div class="bg-white rounded-lg shadow-sm p-6 mb-6">
      <div class="flex items-center gap-2 mb-4">
        <svg class="w-6 h-6 text-amber-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path>
        </svg>
        <h2 class="text-xl font-semibold">Reporte de Pisos y Techos de Inventario (Alertas por Tienda)</h2>
      </div>
      <p class="text-gray-600 mb-4">
        Genera y exporta un informe detallado discriminado por tienda/depósito de todos los productos que están por debajo de su stock mínimo (piso) o superan su stock máximo (techo).
      </p>

      <div class="flex flex-wrap items-end gap-4">
        <div class="w-full md:w-1/3">
          <label class="block text-sm font-medium text-gray-700 mb-1">Filtrar por Depósito / Tienda</label>
          <select v-model="selectedDeposit" class="w-full border-gray-300 rounded-lg shadow-sm focus:border-indigo-500 focus:ring-indigo-500">
            <option value="">Todas las tiendas y depósitos</option>
            <option v-for="dep in deposits" :key="dep.id" :value="dep.id">
              {{ dep.name }}
            </option>
          </select>
        </div>

        <div class="flex flex-wrap gap-3">
          <a
            :href="`/reports/low-stock?format=pdf${selectedDeposit ? '&deposit_id=' + selectedDeposit : ''}`"
            target="_blank"
            class="inline-flex items-center px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors font-medium"
          >
            <i class="fa fa-file-pdf mr-2"></i>
            Descargar PDF
          </a>

          <a
            :href="`/reports/low-stock?format=excel${selectedDeposit ? '&deposit_id=' + selectedDeposit : ''}`"
            target="_blank"
            class="inline-flex items-center px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors font-medium"
          >
            <i class="fa fa-file-excel mr-2"></i>
            Descargar Excel
          </a>
        </div>
      </div>
    </div>

    <div class="bg-white rounded-lg shadow-sm p-6">
      <h2 class="text-xl font-semibold mb-4">Catálogo de Productos</h2>
      <p class="text-gray-600 mb-4">
        Descarga un catálogo completo de todos los productos disponibles en el sistema, incluyendo precios y stock actual.
      </p>
      <a
        :href="`/reports/product-catalog`"
        class="inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
      >
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
          <path fill-rule="evenodd" d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clip-rule="evenodd" />
        </svg>
        Descargar Catálogo
      </a>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput.vue'
import SelectInput from "@/Shared/SelectInput.vue"

export default {
  components: {
    SelectInput,
    TextInput,
    Head,
    Link,
  },
  layout: Layout,
  props: {
    order: String,
    deposits: Object,
    categories: Object,
    organizations: [Array, Object],
    productsSoldout: Array,
  },
  data() {
    return {
      form: this.$inertia.form({
        from: '',
        to: '',
        type: 'excel',
        organization_id: '',
        full: false,
        nulled: '0',
        modality: 'simple',
        orderNumber: this.generateRandomNumber()
      }),
      count: 0,
      selectedDeposit: ''
    }
  },
  methods: {
    generateRandomNumber() {
      return Math.floor(Math.random() * (59999 - 10) + 10)
    },
    generateReport(){
      return this.form.post('/orders/report', {onSuccess: (data) => {
          this.count = 1
          console.log(data)
        }})
    }
  },
}
</script>
